import type { SaleConfiguration } from "~/fragments/saleConfigurations"

/**
 * Picks the sale configuration the box is currently showing.
 *
 * A box with a plan-input counter (`planInputLabel`) is backed by several sale
 * configurations — one per `planInputValue` — and the counter selects between
 * them, so each step is a different main plan (see useProductBoxSlim, where
 * `plan` becomes a `planInputValue -> plan` map and `selectedPlan` reads
 * `plans[selectedQuantity]`). Anything opened from such a box therefore has to
 * follow the counter instead of defaulting to the first configuration.
 *
 * Boxes without a counter have a single configuration and a selected value of
 * 0, which no `planInputValue` matches, so they fall back to the first one —
 * unchanged behaviour.
 */
export default function getSaleConfigurationByPlanInputValue(
  saleConfiguration: SaleConfiguration[],
  selectedPlanInputValue: number
): SaleConfiguration {
  return (
    saleConfiguration.find(
      (configuration) =>
        configuration.flatData.planInputValue === selectedPlanInputValue
    ) ?? saleConfiguration[0]
  )
}
